export const UserStatus=Object.freeze({
    ACTIVE:'ACTIVE',
    PENDING:'PENDING',
    INACTIVE:'INACTIVE'
})